import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const GrammarPlagiarismPage = ({ setPage }) => {
  const [text, setText] = useState('');
  const [result, setResult] = useState(null);
  const [err, setErr] = useState('');

  const run = async () => {
    setErr(''); setResult(null);
    try {
      const res = await fetch(`${API_BASE}/api/text/grammar-plagiarism`, {
        method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ text }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed');
      setResult(data);
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={{...ui.container, maxWidth:860}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>Grammar + Plagiarism Scan</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <textarea value={text} onChange={(e)=>setText(e.target.value)} rows={12} placeholder='Paste text' style={ui.textarea} />
      <button onClick={run} style={{...ui.primaryBtn, marginTop:10}}>Analyze</button>
      {err && <div style={ui.error}>{err}</div>}
      {result && <pre style={{...ui.textarea, ...ui.mono, marginTop:10, whiteSpace:'pre-wrap'}}>{JSON.stringify(result, null, 2)}</pre>}
    </div>
  </div></main>;
};

export default GrammarPlagiarismPage;
